import React, { useState, useEffect } from 'react';

import PaymentButton from './payment_button';
import PortfolioChooser from './portfolio_chooser';

import * as CalculatorFlow from '../shared/calculator_flow';

import RaiseNowInfoWidget from './raise_now_info_widget';

const Form = ({ kg, setKg, setEmissions }) => {
  return (
    <React.Fragment>
      <label htmlFor="weight">Weight of wood (kg):</label>
      <input name="weight" onChange={event => { setEmissions(event.target.value * 0.96799999999999999999); setKg(event.target.value) }} value={kg} />

      <p>A campfire burning for 1 hour uses up about 12kg of wood.</p>
    </React.Fragment>
  );
}

const Compensate = ({ kg, displayState, switchToCalculate, switchToPayment, paymentPortfolio }) => {
  if(kg) {
    return (
      <React.Fragment>
        <div>CO<sub>2</sub> emissions: {kg} kg</div>
        
        { displayState != CalculatorFlow.CALCULATE ? <button onClick={() => switchToCalculate()}>Neu rechnen</button> : null }

        <PortfolioChooser emissions={kg} displayState={displayState} switchToPayment={switchToPayment} paymentPortfolio={paymentPortfolio} />
      </React.Fragment>
    );
  } else {
    return <React.Fragment />;
  }
}

export default props => {
  const [kg, setKg] = useState('');
  const [emissions, setEmissions] = useState();
  const [displayState, setDisplayState] = useState(CalculatorFlow.CALCULATE);
  const [paymentPortfolio, setPaymentPortfolio] = useState();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    if(urlParams.has('dds-subscription')) {
      setDisplayState(CalculatorFlow.MANAGE);
    }
  }, []);

  if(displayState === CalculatorFlow.MANAGE) {
    return ( <RaiseNowInfoWidget /> );
  } else {
    return (
      <React.Fragment>
        <h2>Camp Fire Calculator</h2>

        { displayState === CalculatorFlow.CALCULATE ? <Form kg={kg} setKg={setKg} setEmissions={ setEmissions } /> : null }

        <Compensate kg={emissions} displayState={displayState} switchToCalculate={() => setDisplayState(CalculatorFlow.CALCULATE)} switchToPayment={portfolio => { setPaymentPortfolio(portfolio); setDisplayState(CalculatorFlow.PAYMENT) }} paymentPortfolio={paymentPortfolio} />
      </React.Fragment>
    );
  }
};
